import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/auth';
import { PageLoader } from './ui/PremiumLoader';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

export default function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { isAuthenticated, user, isLoading, pendingVerification } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return <PageLoader text="Loading..." />;
  }

  // SECURITY: Redirect to verification page if email not verified
  if (pendingVerification) {
    return <Navigate to="/verify-email" state={{ from: location }} replace />;
  }

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // SECURITY: Double-check email verification status
  if (!user.emailVerified) {
    return <Navigate to="/verify-email" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Redirect to appropriate dashboard based on role
    const redirectPath = user.role === 'PROFESSOR' ? '/professor' : '/student';
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
}

